// removed by extract-text-webpack-plugin
module.exports = {"location-container":"UpcomingLocation__location-container___1wN2G"};